import { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import Loader from "../../../utils/loader/loader";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePdfList,
  getPdfData,
  getPdfList,
  uploadPdfResource,
} from "../../../Redux/resource/resource.action";
import ToastMessage from "../../../utils/toasts/toastMessage";
import { BASE_IMAGE_URL, GET_PDF_URL} from "../../../utils/api";
import { truncateText } from "../../../utils/utils";
import DeleteConfirmModal from "../../common/deleteConfirmModal/deleteConfirmModal";
import { apiRequest } from "../../../api/apiRequest";

const subjectList = [
  { label: "Python", value: "Python" },
  { label: "JavaScript", value: "JavaScript" },
  { label: "C#", value: "C#" },
  { label: "C", value: "C" },
  { label: "Java", value: "Java" },
  { label: "PHP", value: "PHP" },
  { label: "English", value: "English" },
  { label: "Hindi", value: "Hindi" },
  { label: "Mathematics", value: "Mathematics" },
  { label: "Science", value: "Science" },
  { label: "Social Science", value: "Social Science" },
  { label: "Computer Science", value: "Computer Science" },
  { label: "Sanskrit", value: "Sanskrit" },
  { label: "Physical Education", value: "Physical Education" },
  { label: "Art Education", value: "Art Education" },
  {
    label: "English (Language and Literature)",
    value: "English (Language and Literature)",
  },
  { label: "Hindi (Course A)", value: "Hindi (Course A)" },
  { label: "Hindi (Course B)", value: "Hindi (Course B)" },
  { label: "Physics", value: "Physics" },
  { label: "Chemistry", value: "Chemistry" },
  { label: "Biology", value: "Biology" },
  { label: "Computer Applications", value: "Computer Applications" },
  { label: "Information Technology", value: "Information Technology" },
  { label: "Home Science", value: "Home Science" },
  { label: "Accountancy", value: "Accountancy" },
  { label: "Business Studies", value: "Business Studies" },
  { label: "Economics", value: "Economics" },
  { label: "Engineering Graphics", value: "Engineering Graphics" },
  { label: "Entrepreneurship", value: "Entrepreneurship" },
  { label: "Biotechnology", value: "Biotechnology" },
  { label: "Psychology", value: "Psychology" },
  { label: "History", value: "History" },
  { label: "Geography", value: "Geography" },
  { label: "Political Science", value: "Political Science" },
  { label: "Sociology", value: "Sociology" },
  { label: "Philosophy", value: "Philosophy" },
  { label: "Informatics Practices", value: "Informatics Practices" },
];

const UploadBody = () => {
  const dispatch = useDispatch();

  // reset the file input
  const pdfInputRef = useRef(null);

  // const [deletingFile, setDeletingFile] = useState(null);
  const [qrImage, setQrImage] = useState("");
  const [qrBoxVisible, setQrBoxVisible] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState("Subject");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedConcept, setSelectedConcept] = useState("");
  const [pdfList, setPdfList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  const pdfDataStore = useSelector(
    (state) => state?.ResourceManager?.pdfMetaData,
  );

  useEffect(() => {
    if (pdfDataStore?.length > 0) {
      setLoading(false);
      setPdfList(pdfDataStore);
    } else {
      setLoading(true);
    }
  }, [pdfDataStore]);

  useEffect(() => {
    dispatch(getPdfData());
  }, [dispatch]);

  const resetForm = () => {
    setSelectedSubject("Subject");
    setSelectedChapter("");
    setSelectedConcept("");
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
  };

  const selectPdf = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setToastState({
        show: true,
        message: "No file selected. Try again!",
        type: "error",
      });
      return;
    }

    if (selectedSubject === "Subject" || !selectedChapter.trim()) {
      setToastState({
        show: true,
        message:
          "Please select a Subject and enter a Chapter name before uploading.",
        type: "error",
      });
      // Reset file input so user must re-select after fixing fields
      if (pdfInputRef.current) pdfInputRef.current.value = "";
      return;
    }

    handlePdfUpload(file);
  };

  const handlePdfUpload = async (file) => {
    setLoading(true);

    const payload = {
      file,
      subject: selectedSubject,
      chapter: selectedChapter,
      concept: selectedConcept.trim() || "",
    };

    const result = await dispatch(uploadPdfResource(payload));

    if (result?.success === true) {
      resetForm();
      dispatch(getPdfData());
      setToastState({
        show: true,
        message: "Resource uploaded successfully!",
        type: "success",
      });
    } else {
      // Reset only file input on error so user keeps subject/chapter
      if (pdfInputRef.current) pdfInputRef.current.value = "";
      setToastState({
        show: true,
        message:
          result?.message?.response?.data?.detail ||
          "Upload failed. Please try again.",
        type: "error",
      });
    }

    setLoading(false);
  };

  const handleSubjectSelect = (e, subject) => {
    e.preventDefault();
    setSelectedSubject(subject);
  };

  const handleQrImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setQrImage(URL.createObjectURL(file));
      setQrBoxVisible(true);
    } else {
      setToastState({
        show: true,
        message: "Please upload a valid image file.",
        type: "error",
      });
    }
  };

  const handleQrImageDelete = () => {
    setQrBoxVisible(false);
    setTimeout(() => setQrImage(""), 300);
  };

  const handleDeleteConfirmed = async () => {
    const id = confirmDeleteOpen;
    setConfirmDeleteOpen(null);

    if (!id) return;

    setLoading(true);
    const result = await dispatch(deletePdfList(id));

    if (result?.success) {
      dispatch(getPdfData());
      setToastState({
        show: true,
        message: "Resource deleted successfully!",
        type: "success",
      });
    } else {
      setToastState({
        show: true,
        message: result?.message || "Delete failed. Try again.",
        type: "error",
      });
    }

    setLoading(false);
  };

  const handleDeleteCancelled = () => {
    setConfirmDeleteOpen(null);
  };

  const handleViewFile = async (e, material_id) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await apiRequest(
        "get",
        `${GET_PDF_URL}/${material_id}`,
        null,
        { responseType: "blob" },
      );

      const fileUrl = URL.createObjectURL(result.data);
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      setLoading(false);
    } catch (err) {
      setToastState({
        show: true,
        message: err?.message || "No file selected. Try again!",
        type: "error",
      });
    }
  };

  return (
    <section className="aira-chat">
      <div className="bdrs30 bg-white chat-area chat-area--upload">
        {/* Title */}
        <div className="title-row">
          <div className="title-row__left">
            <h2 className="fw900 fz28">Resource Catalog</h2>
          </div>
        </div>

        {/* Subject / Chapter / Concept inputs */}
        <div className="jumbo-uploads">
          <Dropdown>
            <Dropdown.Toggle className="dd-code" id="dropdown-subject">
              {truncateText(selectedSubject)}
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="py-2 dd-menu"
              style={{ maxHeight: "250px", overflowY: "auto" }}
            >
              {subjectList.map((subject, index) => (
                <Dropdown.Item
                  key={index}
                  className="py-2"
                  value={subject.value}
                  onClick={(e) => handleSubjectSelect(e, subject.label)}
                >
                  {subject.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <div className="m-0 form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Chapter Name"
              value={selectedChapter}
              onChange={(e) => setSelectedChapter(e.target.value)}
            />
          </div>

          <div className="m-0 form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Concept (Topic)"
              value={selectedConcept}
              onChange={(e) => setSelectedConcept(e.target.value)}
            />
          </div>
        </div>

        {/* Legend */}
        <div className="legend">
          <div className="legend-item">
            <span className="circle blue"></span>
            <span>Self</span>
          </div>
          <div className="legend-item">
            <span className="circle yellow"></span>
            <span>Teacher</span>
          </div>
        </div>

        {/* Upload blocks */}
        <div className="blocks">
          {/* PDF Upload Block */}
          <div className="blocks__uploadPdf">
            <div className="user-activity">
              {/* ref for programmatic reset */}
              <input
                ref={pdfInputRef}
                type="file"
                className="form-control"
                id="uploadPdf"
                accept=".pdf, .doc, .docx"
                onChange={selectPdf}
              />
              <div className="custom-file-upload">Choose PDF or DOC file</div>
            </div>

            {/* PDF list */}
            {pdfList?.length > 0 && (
              <ul className="list-inline pdf-list">
                {pdfList.map((file, index) => {
                  // const data = pdfDataStore?.[index];
                  const isTeacher = file?.uploaded_by_role === "teacher";
                  return (
                    <li
                      key={index}
                      className={`pdf-item ${isTeacher ? "teacher-bg" : "self-bg"}`}
                    >
                      <div className="pdf-info">
                        <div className="pdf-info__desc">{file?.file_name}</div>
                        {/* <a
                          href={`${BASE_IMAGE_URL}${file?.file_path}`}
                          className="pdf-info__view"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-eye"></i>
                        </a> */}
                        <button
                          type="button"
                          onClick={(e) => handleViewFile(e, file?.material_id)}
                          aria-label="View file"
                          style={{
                            appearance: "none",
                            border: "none",
                            outline: "none",
                            background: "transparent",
                            padding: 0,
                            margin: 0,
                            cursor: "pointer",
                            font: "inherit",
                            color: "inherit",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </button>

                        {/* FIX 2: delete icon hidden for teacher-uploaded resources */}
                        {!isTeacher && (
                          <a
                            href="#"
                            className="pdf-info__delete"
                            onClick={(e) => {
                              e.preventDefault();
                              setConfirmDeleteOpen(file?.material_id);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </a>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* <div className="blocks__uploadQr">
            <div className="user-activity">
              <input
                type="file"
                className="form-control"
                id="uploadQr"
                accept="image/*"
                onChange={handleQrImageUpload}
              />
              <div className="custom-image-upload">Choose QR Image</div>
            </div>
            <div className={`qr-box-view ${qrBoxVisible ? "fade-in" : "fade-out"}`}>
              {qrImage && (
                <>
                  <img src={qrImage} alt="QR" />
                  <a
                    href="#"
                    className="qr-box-view__view"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-eye"></i>
                  </a>
                  <a
                    href="#"
                    className="qr-box-view__delete"
                    onClick={handleQrImageDelete}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </>
              )}
            </div>
          </div> */}

          {/* URL Block (reserved for future use) */}
          <div className="blocks__url"></div>
        </div>
      </div>

      {confirmDeleteOpen && (
        <DeleteConfirmModal
          show={!!confirmDeleteOpen}
          itemName="this resource"
          loading={loading}
          onCancel={handleDeleteCancelled}
          onConfirm={handleDeleteConfirmed}
        />
      )}

      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default UploadBody;
